var _rect, _circle, _g, _g2, _ellipse, _ellipse2, _ellipse3, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4383_16785)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#0077FF",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4383_16785",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4383_16785)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4383_16785)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint0_linear_4383_16785)",
    fillOpacity: 0.7
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_4383_16785)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 35.8334,
    width: 50,
    height: 79.1667,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 29.166,
    y: 40.8334,
    width: 23.3333,
    height: 4.16667,
    rx: 2.08333,
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 29.166,
    y: 65,
    width: 23.3333,
    height: 4.16667,
    rx: 2.08333,
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.166 49.5C29.166 48.7999 29.166 48.4499 29.3023 48.1825C29.4221 47.9473 29.6133 47.7561 29.8485 47.6362C30.1159 47.5 30.4659 47.5 31.166 47.5H68.8327C69.5327 47.5 69.8828 47.5 70.1502 47.6362C70.3854 47.7561 70.5766 47.9473 70.6964 48.1825C70.8327 48.4499 70.8327 48.7999 70.8327 49.5V58C70.8327 58.7001 70.8327 59.0501 70.6964 59.3175C70.5766 59.5527 70.3854 59.7439 70.1502 59.8638C69.8828 60 69.5327 60 68.8327 60H31.166C30.466 60 30.1159 60 29.8485 59.8638C29.6133 59.7439 29.4221 59.5527 29.3023 59.3175C29.166 59.0501 29.166 58.7001 29.166 58V49.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8327 47.7083H31.166C30.8125 47.7083 30.56 47.7085 30.362 47.7247C30.1664 47.7406 30.0425 47.7712 29.9431 47.8219C29.7471 47.9217 29.5878 48.0811 29.4879 48.2771C29.4372 48.3765 29.4067 48.5004 29.3907 48.696C29.3745 48.894 29.3743 49.1465 29.3743 49.5V58C29.3743 58.3535 29.3745 58.606 29.3907 58.804C29.4067 58.9996 29.4372 59.1235 29.4879 59.2229C29.5878 59.4189 29.7471 59.5783 29.9431 59.6781C30.0425 59.7288 30.1664 59.7594 30.362 59.7753C30.56 59.7915 30.8125 59.7917 31.166 59.7917H68.8327C69.1861 59.7917 69.4387 59.7915 69.6367 59.7753C69.8323 59.7594 69.9562 59.7288 70.0556 59.6781C70.2516 59.5783 70.4109 59.4189 70.5108 59.2229C70.5615 59.1235 70.592 58.9996 70.608 58.804C70.6242 58.606 70.6243 58.3535 70.6243 58V49.5C70.6243 49.1465 70.6242 48.894 70.608 48.696C70.592 48.5004 70.5615 48.3765 70.5108 48.2771C70.4109 48.0811 70.2516 47.9217 70.0556 47.8219C69.9562 47.7712 69.8323 47.7406 69.6367 47.7247C69.4387 47.7085 69.1861 47.7083 68.8327 47.7083ZM29.3023 48.1825C29.166 48.4499 29.166 48.7999 29.166 49.5V58C29.166 58.7001 29.166 59.0501 29.3023 59.3175C29.4221 59.5527 29.6133 59.7439 29.8485 59.8638C30.1159 60 30.466 60 31.166 60H68.8327C69.5327 60 69.8828 60 70.1502 59.8638C70.3854 59.7439 70.5766 59.5527 70.6964 59.3175C70.8327 59.0501 70.8327 58.7001 70.8327 58V49.5C70.8327 48.7999 70.8327 48.4499 70.6964 48.1825C70.5766 47.9473 70.3854 47.7561 70.1502 47.6362C69.8828 47.5 69.5327 47.5 68.8327 47.5H31.166C30.4659 47.5 30.1159 47.5 29.8485 47.6362C29.6133 47.7561 29.4221 47.9473 29.3023 48.1825Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.166 73.6667C29.166 72.9667 29.166 72.6166 29.3023 72.3493C29.4221 72.1141 29.6133 71.9228 29.8485 71.803C30.1159 71.6667 30.4659 71.6667 31.166 71.6667H68.8327C69.5327 71.6667 69.8828 71.6667 70.1502 71.803C70.3854 71.9228 70.5766 72.1141 70.6964 72.3493C70.8327 72.6166 70.8327 72.9667 70.8327 73.6667V82.1667C70.8327 82.8668 70.8327 83.2168 70.6964 83.4842C70.5766 83.7194 70.3854 83.9107 70.1502 84.0305C69.8828 84.1667 69.5327 84.1667 68.8327 84.1667H31.166C30.466 84.1667 30.1159 84.1667 29.8485 84.0305C29.6133 83.9107 29.4221 83.7194 29.3023 83.4842C29.166 83.2168 29.166 82.8668 29.166 82.1667V73.6667Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8327 71.8751H31.166C30.8125 71.8751 30.56 71.8752 30.362 71.8914C30.1664 71.9074 30.0425 71.938 29.9431 71.9886C29.7471 72.0885 29.5878 72.2478 29.4879 72.4438C29.4372 72.5433 29.4067 72.6672 29.3907 72.8627C29.3745 73.0607 29.3743 73.3133 29.3743 73.6667V82.1667C29.3743 82.5202 29.3745 82.7728 29.3907 82.9708C29.4067 83.1663 29.4372 83.2902 29.4879 83.3897C29.5878 83.5857 29.7471 83.745 29.9431 83.8449C30.0425 83.8955 30.1664 83.9261 30.362 83.9421C30.56 83.9583 30.8125 83.9584 31.166 83.9584H68.8327C69.1861 83.9584 69.4387 83.9583 69.6367 83.9421C69.8323 83.9261 69.9562 83.8955 70.0556 83.8449C70.2516 83.745 70.4109 83.5857 70.5108 83.3897C70.5615 83.2902 70.592 83.1663 70.608 82.9708C70.6242 82.7728 70.6243 82.5202 70.6243 82.1667V73.6667C70.6243 73.3133 70.6242 73.0607 70.608 72.8627C70.592 72.6672 70.5615 72.5433 70.5108 72.4438C70.4109 72.2478 70.2516 72.0885 70.0556 71.9886C69.9562 71.938 69.8323 71.9074 69.6367 71.8914C69.4387 71.8752 69.1861 71.8751 68.8327 71.8751ZM29.3023 72.3493C29.166 72.6166 29.166 72.9667 29.166 73.6667V82.1667C29.166 82.8668 29.166 83.2168 29.3023 83.4842C29.4221 83.7194 29.6133 83.9107 29.8485 84.0305C30.1159 84.1667 30.466 84.1667 31.166 84.1667H68.8327C69.5327 84.1667 69.8828 84.1667 70.1502 84.0305C70.3854 83.9107 70.5766 83.7194 70.6964 83.4842C70.8327 83.2168 70.8327 82.8668 70.8327 82.1667V73.6667C70.8327 72.9667 70.8327 72.6166 70.6964 72.3493C70.5766 72.1141 70.3854 71.9228 70.1502 71.803C69.8828 71.6667 69.5327 71.6667 68.8327 71.6667H31.166C30.4659 71.6667 30.1159 71.6667 29.8485 71.803C29.6133 71.9228 29.4221 72.1141 29.3023 72.3493Z",
    fill: "#0077FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4383_16785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.416 64.6667L59.416 53.6667L68.416 59.6667L64.416 60.6667L67.916 65.6667L66.416 66.6667L62.916 61.6667L60.416 64.6667Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9181 64.712L60.0274 65.9142L60.8001 64.9868L62.8814 62.4893L66.0064 66.9535L66.2867 67.3539L66.6934 67.0828L68.1934 66.0828L68.619 65.799L68.3256 65.38L65.2425 60.9755L68.5373 60.1518L69.6338 59.8777L68.6934 59.2507L59.6934 53.2507L58.8234 52.6708L58.9181 53.712L59.9181 64.712Z",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 35.3334,
    width: 51,
    height: 80.1667,
    rx: 2.5,
    stroke: "#F1F5F9"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.3333,
    cy: 25.4167,
    rx: 2.08333,
    ry: 2.08333,
    fill: "url(#paint1_linear_4383_16785)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.9993,
    cy: 25.4167,
    rx: 2.08333,
    ry: 2.08333,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.6673,
    cy: 25.4167,
    rx: 2.08333,
    ry: 2.08333,
    fill: "url(#paint2_linear_4383_16785)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 49.5,
    stroke: "#F1F5F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4383_16785",
    x: -44,
    y: -44,
    width: 188,
    height: 188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22,
    result: "effect1_foregroundBlur_4383_16785"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_4383_16785",
    x: 21,
    y: 32.8334,
    width: 58,
    height: 87.1666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4383_16785"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4383_16785",
    result: "effect2_dropShadow_4383_16785"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4383_16785",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4383_16785",
    x: 56.2305,
    y: 50.6748,
    width: 16.6211,
    height: 20.3662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4383_16785"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4383_16785",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4383_16785",
    x1: 74.375,
    y1: 6.66666,
    x2: 2.5,
    y2: 56.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562024,
    stopColor: "#0077FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4383_16785",
    x1: 42.0833,
    y1: 23.75,
    x2: 45.4167,
    y2: 27.0834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4383_16785",
    x1: 55.4173,
    y1: 23.75,
    x2: 58.7507,
    y2: 27.0834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4383_16785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/Empty.b3ce57c4de58f91a3d33fa0a167f6893.svg";
export { ForwardRef as ReactComponent };